import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const moversLanding = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/movers/moversMainLanding')(moversLanding);
